var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#15B79E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 10.25,
    cy: 10,
    r: 4,
    fill: "#15B79E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStepIcon);
export default __webpack_public_path__ + "static/media/active-step-icon.ef80d07c89202858645f4ee1cb87f7a5.svg";
export { ForwardRef as ReactComponent };